import { render, staticRenderFns } from "./AfterSale.vue?vue&type=template&id=511ef530&scoped=true&"
import script from "./AfterSale.vue?vue&type=script&lang=js&"
export * from "./AfterSale.vue?vue&type=script&lang=js&"
import style0 from "./AfterSale.vue?vue&type=style&index=0&id=511ef530&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511ef530",
  null
  
)

export default component.exports